import { Component, HostBinding, ChangeDetectionStrategy, ViewEncapsulation, Input, Output, EventEmitter, forwardRef,
    ChangeDetectorRef } from '@angular/core';
import { coerceBooleanProperty } from '@angular/cdk/coercion';
import { NG_VALUE_ACCESSOR, ControlValueAccessor, FormControl } from '@angular/forms';
import { MatSlideToggleChange } from '@angular/material/slide-toggle';
import { uniqueId } from '@eui/core';

import { BaseDirective } from '../../base.directive';

@Component({
    templateUrl: './eui-slide-toggle.component.html',
    selector: 'eui-slide-toggle',
    styleUrls: ['./styles/index.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    providers: [{
        provide: NG_VALUE_ACCESSOR,
        useExisting: forwardRef(() => EuiSlideToggleComponent),
        multi: true,
    }],
})
export class EuiSlideToggleComponent extends BaseDirective implements ControlValueAccessor {

    @Input() id: string = `eui-slide-toggle-${uniqueId()}`;
    @Input()
    get isChecked() { return this._isChecked; }
    set isChecked(value) { this._isChecked = coerceBooleanProperty(value); }
    _isChecked = false;

    @Input()
    get disabled() { return this._disabled; }
    set disabled(value) { this._disabled = coerceBooleanProperty(value); }
    _disabled = false;

    @Output() changed = new EventEmitter<boolean>();

    @HostBinding('class')
    get cssClasses() {
        return [
            super.getCssClasses('eui-slide-toggle'),
        ].join(' ').trim();
    }

    public slideToggleControl = new FormControl();

    constructor(private cd: ChangeDetectorRef) {
        super();
    }

    public onSlideChange(e: MatSlideToggleChange): void {
        this.isChecked = e.checked;
        this.changed.emit(e.checked);
        this.onChange(e.checked);
    }

    public writeValue(value: boolean): void {
        this.isChecked = value;
        this.cd.detectChanges();
    }

    public setDisabledState(isDisabled: boolean): void {
        this.disabled = isDisabled;
        this.cd.detectChanges();
    }

    public registerOnChange(fn: any): void {
        this.onChange = fn;
    }

    public registerOnTouched(fn: any): void {
        this.onTouch = fn;
    }

    private onChange: any = () => {};

    private onTouch: any = () => {};
}
